// extracted by mini-css-extract-plugin
export default {"container":"AM-z","dimension":"BM-z","dimensionLabels":"CM-z"};